var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button_add photo",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.click}},[_c('i',{staticClass:"icon-add-white"}),_c('span',[_vm._v(_vm._s(_vm.$t('Ещё'))),_c('br'),_vm._v(" "+_vm._s(_vm.$t('фото')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }